import { render, staticRenderFns } from "./EmbedYoutubeVideo.vue?vue&type=template&id=69bf59ce&scoped=true&"
import script from "./EmbedYoutubeVideo.vue?vue&type=script&lang=ts&"
export * from "./EmbedYoutubeVideo.vue?vue&type=script&lang=ts&"
import style0 from "./EmbedYoutubeVideo.vue?vue&type=style&index=0&id=69bf59ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bf59ce",
  null
  
)

export default component.exports